if (!customElements.get('e8-belt-craft')) {
  customElements.define('e8-belt-craft', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const sourceProduct = data?.html?.querySelector('product-info[data-product-id]');
        if (!data?.variant || sourceProduct?.dataset.productId !== this.dataset.productId) return;
        const variant = data.variant;
        const image = this.querySelector('.e8-craft__image');
        const media = variant.featured_media?.preview_image ?? variant.featured_image;
        const source = media?.src ?? media?.url;
        if (image && source) {
          const imageUrl = new URL(source, window.location.origin);
          imageUrl.searchParams.set('width', '1100');
          image.removeAttribute('srcset');
          image.src = imageUrl.href;
          image.alt = this.dataset.imageAlt;
        }
        const hardware = this.querySelector('[data-hardware-label]');
        const index = Number(this.dataset.hardwareOption) - 1;
        if (hardware && index >= 0 && variant.options?.[index]) {
          hardware.textContent = variant.options[index].replace('Nickle', 'Nickel');
        }
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
